import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimSystemExtendedService} from "@services";
import {AssessableItem, ChecklistItem, ChecklistItemType} from "@models";
import {Translations} from "@translations";

export interface DialogData_ChangeTypeOfChecklistItemInput<T extends AssessableItem> extends MatDialogDataBaseInput {
	checklistItem: T;
}

export interface DialogData_ChangeTypeOfChecklistItemOutput extends MatDialogDataBaseOutput {
	selectedChecklistType: ChecklistItemType;
	migrateExistingPossibilities: boolean;
}

@Component({
	selector: "sim-change-type-of-checklist-entry",
	templateUrl: "./change-type-of-checklist-item.component.html",
	styleUrls: ["./change-type-of-checklist-item.component.scss"],
	standalone: false,
})
export class ChangeTypeOfChecklistItemComponent<T extends AssessableItem> extends BasicMaterialDialog<
	ChangeTypeOfChecklistItemComponent<T>,
	DialogData_ChangeTypeOfChecklistItemInput<T>,
	DialogData_ChangeTypeOfChecklistItemOutput
> {
	T = Translations;

	ChecklistType = ChecklistItemType;
	startingChecklistType: ChecklistItemType;
	selectedChecklistType: ChecklistItemType;
	migrateExistingOptions: boolean = true;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		_injector: Injector,
	) {
		super(_injector);

		this.startingChecklistType = this.data.checklistItem.type;
		this.selectedChecklistType = this.startingChecklistType;
	}

	updateType() {
		let migrateExistingOptions = false;

		if (
			(this.startingChecklistType === ChecklistItemType.MultipleChoiceOption ||
				this.startingChecklistType === ChecklistItemType.SingleChoiceOption) &&
			(this.selectedChecklistType === ChecklistItemType.MultipleChoiceOption ||
				this.selectedChecklistType === ChecklistItemType.SingleChoiceOption)
		) {
			migrateExistingOptions = this.migrateExistingOptions;
		}

		super.close({
			action: "ok",
			selectedChecklistType: this.selectedChecklistType,
			migrateExistingPossibilities: migrateExistingOptions,
		});
	}
}
